import { CSSProperties, ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IContentAreaProps, IFilterData, ICasterProduction, IProduction, IState } from "../../../../types";
import { useFetch } from "../../../../system/useFetch";
import FilterComponentBase from "../../../../components/filterComponentBase";
import SkeletonView from "../../../../components/skeletonView";
import { Alert, Paper } from "@mui/material";
import { PollInterval5Min } from "../../../../system/utils";
import ProductionHeader from "./productionHeader";
import ProductionChart from "./productionChart";
import ProductionTabPanel from "./productionTabPanel";
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const expandedChartsHeight = 240;
const collapseChartsHeight = 26;

const ProductionReportCaster = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const [productionData, setProductionData] = useState<ICasterProduction[] | null>(null);
  const [open, setOpen] = useState(false);
  const { loading, error, data: response } = useFetch<IProduction[]>(
    {
      module: "production",
      query: "getProductionGanttByFilter",
      payload: { ...filter.remote }
    }, filter.local.mode === "REAL_TIME" ? PollInterval5Min : 0);

  useEffect(() => {
    if (!response) {
      setProductionData(null);

      return;
    }

    const list: ICasterProduction[] = [];

    response.forEach(row => {
      row.productionMachines.forEach(machineData => list.push(machineData as ICasterProduction));
    });

    setProductionData(list.length > 0 ? list : null);
  }, [response]);

  const gridStyle: CSSProperties = {
    position: "relative",
    // ...parentSize,
    gridTemplateRows: "auto auto 1fr",
    gridTemplateColumns: "1fr",
    alignItems: "stretch"
  };

  const contentStyle = {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr",
    gridRow: "3 / span 1",
    overflow: "hidden"
  };

  return (
    <div className="display-grid" style={gridStyle}>
      <FilterComponentBase loading={loading}/>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !productionData && <Alert severity="warning">No Data to Display.</Alert>}

      {productionData &&
        <div className="display-grid" style={contentStyle}>
          <Paper className="mb-1" style={{ height: open ? expandedChartsHeight : collapseChartsHeight, position: "relative"  }}>
            <div className="display-flex-row align-items-center" style={{ position: "absolute", left: 0, top: 0 }}>
              <IconButton onClick={() => setOpen(!open)} size={"small"} className="mr-1">
                {open
                  ? <ExpandLessIcon fontSize="inherit" fontWeight="bold"/>
                  : <ExpandMoreIcon fontSize="inherit" fontWeight="bold"/>
                }
              </IconButton>

              {!open && <strong>Charts</strong>}
            </div>
            {open && <div className="display-flex-column">
              <ProductionHeader productionData={productionData} />
              <ProductionChart productionData={productionData} />
            </div>}
          </Paper>
          <ProductionTabPanel productionData={productionData} parentSize={{ ...parentSize, height: parentSize.height - (open ? 300 : 90) }} />
        </div>
      }
    </div>
  );
};


export default ProductionReportCaster;








